
import { Model } from './model';

export class StepModel implements Model {


  name: string;
  ss_id: number;
  id: string;
  bddKeyword: string;
  suser: string;
  action: string;
  object: string;
  commandSteps: string[];
  _type = "step";
  dbName?: string;
  // "web_recorder" for a step saved by the recorder's "Save Steps" checkbox; undefined otherwise.
  source?: string;
}
